export default "__VITE_ASSET__BZKJXScg__"